const HOST_URL = process.env.REACT_APP_BASE_URL
export { HOST_URL }